module.exports = __webpack_public_path__ + "media/images/gerb_minzdrava_2-d7771425e98cc18601af0526fc7d6c3c.png";